import { FC, ReactNode } from "react";
import {
  Flex,
  FormLabel,
  Checkbox as ChakraCheckbox,
} from "@chakra-ui/react";
import { Check } from "~/icons";

interface CheckboxArrayItemProps {
  id?: string;
  fieldName: string;
  value: string;
  label: ReactNode;
  isChecked: boolean;
  onChange: (checked: boolean) => void;
}

export const CheckboxArrayItem: FC<CheckboxArrayItemProps> = ({
  id,
  fieldName,
  value,
  label,
  isChecked,
  onChange,
}) => {
  const checkboxId = id || `${fieldName}_${value}`;

  return (
    <Flex align="flex-start">
      <ChakraCheckbox
        id={checkboxId}
        icon={<Check h={4} w={4} />}
        mr={2}
        mt={1}
        size="lg"
        variant="th-checkbox"
        value={value}
        isChecked={isChecked}
        onChange={(e) => onChange(e.target.checked)}
      />
      <FormLabel htmlFor={checkboxId} m="0" cursor="pointer">
        {label}
      </FormLabel>
    </Flex>
  );
};